import React from 'react';
import { useTranslation } from 'react-i18next';
import { AlertCard } from '../patterns';
import type { NutritionSummary } from '../../services/nutritionService';

export const NutritionAlertStack: React.FC<{
  inventory?: NutritionSummary['inventory'];
  needsLinking: number;
}> = ({ inventory, needsLinking }) => {
  const { t } = useTranslation();
  const dwellCount = inventory ? inventory.dwellBreaches + inventory.dwellLow : 0;
  return (
    <div className="ntr-dash-alerts">
      {inventory && dwellCount > 0 && (
        <AlertCard
          tone="danger"
          count={dwellCount}
          viewAllHref="/nutrition/inventory"
          title={t('nutrition.dashboard.alerts.dwell.title')}
        >
          {t('nutrition.dashboard.alerts.dwell.body', { count: dwellCount })}
        </AlertCard>
      )}
      {inventory && inventory.orderNeedCount > 0 && (
        <AlertCard
          tone="warn"
          count={inventory.orderNeedCount}
          viewAllHref="/nutrition/inventory"
          title={t('nutrition.dashboard.alerts.order.title')}
        >
          {t('nutrition.dashboard.alerts.order.body', { count: inventory.orderNeedCount })}
        </AlertCard>
      )}
      {needsLinking > 0 && (
        <AlertCard
          tone="warn"
          count={needsLinking}
          viewAllHref="/nutrition/products"
          title={t('nutrition.dashboard.alerts.needsLinking.title')}
        >
          {t('nutrition.dashboard.alerts.needsLinking.body', { count: needsLinking })}
        </AlertCard>
      )}
    </div>
  );
};

export default NutritionAlertStack;
